import { AfterContentInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChild, ContentChildren, Input, OnInit, Optional, QueryList, ViewChildren } from '@angular/core';
import { TableHeaderComponent } from '../table-header/table-header.component';
import { TableColumnComponent } from '../table-column/table-column.component';
import { TableComponent } from '../table/table.component';

@Component({
  selector: 'app-table-row',
  templateUrl: './table-row.component.html',
  styleUrls: ['./table-row.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableRowComponent implements OnInit, AfterContentInit {
  @Input() href: string | null = null;
  @Input("no-background") noBackground = false; 
  @Input() background: string | null;
  @Input() isTemporary: boolean = false;

  columnCount!: number;

  @ContentChildren(TableColumnComponent) columns: QueryList<TableColumnComponent>;

  constructor(
    private changeDetector: ChangeDetectorRef,
    private table: TableComponent
  ) {}

    ngOnInit(): void {
      
    this.table.tableRows.push(this);
    }

  ngAfterContentInit() {


    if (this.href) {
      this.columnCount = this.columns.length + 2;
    } else {
      this.columnCount = this.columns.length + 1;
    }

    this.changeDetector.detectChanges();
  }
}
